import { FC } from "react";
import { useTranslation } from "react-i18next";

import styles from "./ConfirmDeleteTrendAlertModal.module.scss";
import { ConfirmModal } from "src/features";
import { useAppDispatch } from "src/store";
import { showToastNotification } from "src/utils";
import { useGlobalPreloader, useModal } from "src/hooks";

import { deleteTrendAlert } from "src/store/trendAlerts/trendAlertsSlice";

type Props = {
  alertId: TrendAlert.Data["id"];
};

export const ConfirmDeleteTrendAlertModal: FC<Props> = ({ alertId }) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const { closeModal } = useModal();

  const { showGlobalPreloader, hideGlobalPreloader } = useGlobalPreloader();

  const onSubmit = async (): Promise<void> => {
    try {
      showGlobalPreloader();

      await dispatch(deleteTrendAlert(alertId)).unwrap();

      showToastNotification({
        type: "success",
        text: t(
          "component.modal.delete_trend_alert.status.success.trend_alert_deleted",
        ),
      });
    } catch (error) {
      console.error(error);

      showToastNotification({
        type: "error",
        text: t("common.error.server_error_reload"),
      });
    } finally {
      closeModal("confirm-delete-trend-alert");
      hideGlobalPreloader();
    }
  };

  return (
    <ConfirmModal
      id="confirm-delete-trend-alert"
      type="warning"
      acceptButton={{
        text: t("component.modal.delete_trend_alert.button.submit"),
        buttonType: "error",
        onClick: onSubmit,
      }}
      cancelButton={{
        text: t("component.modal.delete_trend_alert.button.cancel"),
        onClick: () => closeModal("confirm-delete-trend-alert"),
      }}
      title={t("component.modal.delete_trend_alert.title")}
    >
      <div className={styles.wrapper}>
        <span>{t("component.modal.delete_trend_alert.body")}</span>
      </div>
    </ConfirmModal>
  );
};
